export default __webpack_public_path__ + "static/images/sound_true.33dd5f73.png";